import axios from "axios"
import React, { useState } from "react"
import { ResourceType, Resources } from "../Resources"

export const usePost = (
  resource: ResourceType,
  params?: Record<string, any>
) => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const [data, setData] = useState()

  const { name, url } = Resources[resource]

  const save = React.useCallback(
    (data: any) => {
      setLoading(true)
      return axios
        .post(url, data, { params })
        .then((x: any) => {
          setLoading(false)
          setData(x)
          setError(false)

          return x
        })
        .catch(e => {
          setLoading(false)
          setError(e)
          setData(undefined)

          return e
        })
    },
    [resource]
  )

  return { loading, data, save, error }
}
